import useWindowSize from './useWindowSize';

const useIsMobile = () => {
  const { width } = useWindowSize();

  return width < 992;
};

export default useIsMobile;
